import React from 'react';
import PlusIconSvg from './Plus.svg';

const PlusIcon = (props) => (
    /* TODO - change to 'webpack inlined' when on react-scripts 2.0 - https://facebook.github.io/create-react-app/docs/adding-images-fonts-and-files#adding-svgs */
    <img src={PlusIconSvg} alt="Expand" {...props} />
);

export default PlusIcon;
